<template>
	<div
		class="d-flex flex-column d-lg-flex flex-lg-column flex-xl-row justify-content-lg-between px-lg-0 align-items-lg-center position-relative"
	>
		<div class="col-12 col-xl-6 px-0">
			<div class="d-flex flex-column flex-lg-row nowrap text-grey-900" v-if="specialStay">
				<span
					v-if="!isDisplayPlaceholders && store.state.packCode !== 'HS'"
					class="me-4 text-nowrap caption"
				>
					<div class="caption-strong text-grey-900 mt-1">
						{{ store.state.content.planner_shortStay_rate }}
						<span v-if="(props.variant.codePackage === 'PFTTF' || props.variant.codePackage === 'PFPTTF') && props.variant.skipass">
							{{ props.variant.skipass }}
						</span>
						{{ store.state.content.days }}
					</div>
					<span class="me-1">{{
						store.state.content.planner_prestationsInclude
					}}</span>
					<svg class="icon info-icon tf-icon-10 tf-icon-sm-20">
						<use xlink:href="#___icon___info"></use>
					</svg>
					:
					<template v-if="store.getters.packageInfoContent[0]">
						<PackageDetalisPopUp>
							<span v-for="(content, content_i) in store.getters.packageInfoContent" :key="`${content[0]}-${content_i}}`">{{ content }}</span>
						</PackageDetalisPopUp>
					</template>
				</span> 

				<div class="d-flex flex-column flex-lg-row align-items-start">
					<Inclus
						:isDisplayPlaceholders="isDisplayPlaceholders"
						:variant="variant"
						class="mb-3 mb-lg-0 me-lg-4"
					/>
					<PaymentCondition v-if="specialStay" :paymentCondition="variant.paymentCondition" :cancellation-date="variant.cancelationUntil" :displayTitle="true" :prestId="prestId" :isDisplayPlaceholders="isDisplayPlaceholders" class="d-flex align-items-center w-100 h-100" />
				</div>
			</div>
			<PaymentCondition v-if="!specialStay" :paymentCondition="variant.paymentCondition" :cancellation-date="variant.cancelationUntil" :displayTitle="true" :prestId="prestId" :isDisplayPlaceholders="isDisplayPlaceholders"/>
		</div>
		<div
			class="col-12 col-xl-6 px-0 d-flex flex-lg-row nowrap justify-content-end align-items-end"
		>
			<div
				class="d-flex flex-column d-lg-flex flex-lg-row justify-content-center align-items-center w-100 px-0 px-lg-2"
			>
				<div class="col-12 col-lg-7 px-0 pe-lg-1">
					<Prices
						:isLoading="pricesLoadingSet.has(currentCacheKey)"
						:isDisplayPlaceholders="isDisplayPlaceholders"
						:packCode="variant && variant.codePackage"
						:crossedPrice="crossedPrice"
						:totalPrice="totalPrice"
						:perPrice="perPrice"
						:maxPromo="maxPromo"
						:locale="store.getters.locale"
					/>
				</div>
				<span class="d-none d-lg-inline-block position-relative pe-lg-3">
					<svg class="info-icon icon tf-icon-10 tf-icon-sm-20">
						<use xlink:href="#___icon___info"></use>
					</svg>
					<PackageDetalisPopUp
						:top="'0'"
						:left="'10px'"
					>
					{{ store.state.content.planner_prestationsPriceInfo }}
				</PackageDetalisPopUp>
				</span>
				<div
					class="col-12 col-sm-6 col-lg-6 col-lg-5 px-0 d-flex align-items-center justify-content-center accommodation-btn"
				>
					<SelectButton
						:isDisplayPlaceholders="isDisplayPlaceholders"
						:variant="variant"
						:selectedQuantity="selectedQuantity"
						:select_location="'prestation'"
						@selectClick="(id) => emit('select', id)"
						@clear="(id) => emit('clear', id)"
						@dropdownClick="(payload) => emit('dropdownClick', payload)"
 						@dropdownSelect="(payload) => emit('dropdownSelect', payload)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {
	defineProps,
	withDefaults,
	defineEmits,
	computed,
	ComputedRef,
	Ref,
	ref,
} from "vue";

// Store
//import store from "@/vue/planning/store/store";

// State
import responsesCache from "@/vue/planning/state/responsesCache";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";

// Components
import Prices from "@/vue/planning/components/common/prices.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue";
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"

// Computed
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";

// Logic
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount";
import { isCS } from "@/vue/planning/logic/cs";


import { useStore } from "vuex"
const store = useStore();

interface Props {
	variant: any;
	isDisplayPlaceholders: boolean;
}
interface Emits {
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}

const props = withDefaults(defineProps<Props>(), {
	isDisplayPlaceholders: false,
});
const emit = defineEmits<Emits>();

// computed
const selectedQuantity: ComputedRef<number> = computed(() => {
	return props.variant && store.state.selectedPrestIds[props.variant.id];
});

const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN;
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
});

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
});

const totalPrice: ComputedRef<number> = computed(() => {
	return props.variant && getPrestTotalPrice(props.variant);
});

const maxPromo: ComputedRef<number> = computed(() => {
	return props.variant && getPrestMaxPromo(props.variant);
});

const prestId: ComputedRef<string> = computed(() => {
	return props.variant.prestIdSource
})

const specialStay: ComputedRef<boolean> = computed(() => {
	// Original NL case
	const isNLSkiPass = props.variant && props.variant.isNewSkiPassValid;
	
	// FR case - only show skipass days if there are multiple variants with different skipass durations
	const hasMultipleSkipassDurations = props.variant && 
		store.getters.isLocaleFR && 
		props.variant.prestation && 
		props.variant.prestation.variants && 
		new Set(props.variant.prestation.variants
			.filter((v: { codePackage?: string }) => v.codePackage === props.variant.codePackage)
			.map((v: { skipass?: number }) => v.skipass))
		.size > 1;
		
	const isFRSkiPass = hasMultipleSkipassDurations && 
		(props.variant.skipass === 7 || props.variant.skipass === 8) && 
		(props.variant.codePackage === "PFTTF" || props.variant.codePackage === "PFPTTF");
		
	return (props.variant && isCS(props.variant)) || isNLSkiPass || isFRSkiPass;
});
</script>

<style scoped>
/* Handles packageDetailsPoup showing */
.info-icon:hover + .package-info-container {
	visibility: visible;
}

@media (max-width: 1400px) {
  .accommodation-btn {
    min-width: 16vw
  }

  .accommodation-btn button{
    margin-right: .20rem !important
  }
}
</style>
